import FarmsGridRowWrapper from 'components/FarmsGrid/components/FarmsGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FarmsGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <FarmsGridRowWrapper ref={ref} testId={testId}>
        {children}
    </FarmsGridRowWrapper>
);

export default FarmsGridHeader;
